const namespace = 'SALE_CHANNELS';

export const REQUEST_SALE_CHANNELS = `${namespace}/REQUEST_SALE_CHANNELS`;
export const RECEIVE_SALE_CHANNELS_SUCCESS = `${namespace}/RECEIVE_SALE_CHANNELS_SUCCESS`;
export const RECEIVE_SALE_CHANNELS_FAILURE = `${namespace}/RECEIVE_SALE_CHANNELS_FAILURE`;